export const UPDATE_PAGINATION_TOTAL_FLOW: string = "UPDATE_PAGINATION_TOTAL_FLOW";
export const UPDATE_PAGINATION_POSTS_PER_PAGE_FLOW: string = "UPDATE_PAGINATION_POSTS_PER_PAGE_FLOW";
export const UPDATE_PAGINATION_CURRENT_PAGE_FLOW: string = "UPDATE_PAGINATION_CURRENT_PAGE_FLOW";
export const UPDATE_LOADING_STATE_FLOW: string = "UPDATE_LOADING_STATE_FLOW";
export const UPDATE_NOTFOUND_STATE_FLOW: string = "UPLOAD_NOTFOUND_STATE_FLOW";
export const UPDATE_TABLE_STATE_FLOW: string = "UPDATE_TABLE_STATE_FLOW";
export const UPDATE_SEARCH_FLOW: string = "UPDATE_SEARCH_FLOW";
export const UPDATE_SEARCH_CURRENT_PAGE_FLOW: string = "UPDATE_SEARCH_CURRENT_PAGE_FLOW";

export function updateFlowsPaginationtTotal(totalPostsFlow: number): IUpdatePaginationTotalActionType {
    return { type: UPDATE_PAGINATION_TOTAL_FLOW, totalPostsFlow:totalPostsFlow };
}
export function updateFlowsPaginationtPostsPerPage(postsPerPageFlow: number): IUpdatePaginationPostsPerPageActionType {
    return { type: UPDATE_PAGINATION_POSTS_PER_PAGE_FLOW, postsPerPageFlow:postsPerPageFlow };
}
export function updateFlowsPaginationcurrentPage(currentPageFlow: number): IUpdatePaginationCurrentPageActionType {
    return { type: UPDATE_PAGINATION_CURRENT_PAGE_FLOW, currentPageFlow:currentPageFlow };
}
export function updateFlowsLoadingState(loadingFlow: string): IUpdateLoadingStateActionType {
    return { type: UPDATE_LOADING_STATE_FLOW, loadingFlow:loadingFlow };
}
export function updateFlowsNFState(notFoundFlow: string): IUpdateNFStateActionType {
    return { type: UPDATE_NOTFOUND_STATE_FLOW, notFoundFlow:notFoundFlow };
}
export function updateFlowsTableState(tableFlow: string): IUpdateTableStateActionType {
    return { type: UPDATE_TABLE_STATE_FLOW, tableFlow:tableFlow };
}
export function updateFlowsSearchState(searchFlow: string): IUpdateSearchStateActionType {
    return { type: UPDATE_SEARCH_FLOW, searchFlow:searchFlow };
}
export function updateFlowsSearchCurrentPageState(currentPageSearchFlow: number): IUpdateCurrentPageSearchStateActionType {
    return { type: UPDATE_SEARCH_CURRENT_PAGE_FLOW, currentPageSearchFlow:currentPageSearchFlow };
}

interface IUpdatePaginationTotalActionType { 
    type: string, 
    totalPostsFlow: number
}

interface IUpdatePaginationPostsPerPageActionType { 
    type: string, 
    postsPerPageFlow: number
}

interface IUpdatePaginationCurrentPageActionType { 
    type: string, 
    currentPageFlow: number
}

interface IUpdateLoadingStateActionType { 
    type: string, 
    loadingFlow: string
}

interface IUpdateNFStateActionType { 
    type: string, 
    notFoundFlow: string
}

interface IUpdateTableStateActionType { 
    type: string, 
    tableFlow: string
}

interface IUpdateSearchStateActionType { 
    type: string, 
    searchFlow: string
}

interface IUpdateCurrentPageSearchStateActionType { 
    type: string, 
    currentPageSearchFlow: number
}